import * as React from 'react';
import { ExternalLink } from 'react-external-link';
import { API_URL } from '../../Constants';
import {logout} from '../../helpers/Login';
import {polyglot} from '../../helpers/Polyglot';
import {LocalesKeys} from '../../localesKeys';
import styles from '../ActivationForm/ActivationForm.scss';
import { Logo } from '../Logo/Logo';

export interface ActivationSuccessProps {
    currentAccountKey: string;
    joinMode: boolean;
}

export const ActivationSuccess = ({ currentAccountKey, joinMode }: ActivationSuccessProps) => {

    const joinText = () => (<>
            <div className={styles.JoinOnly}>{polyglot.t(LocalesKeys.joinOnlyTitle)}</div>
            <div>
                <div className={styles.JoinOnlySubTitle}>{polyglot.t(LocalesKeys.joinOnlySubTitle)}​</div>
                <div dangerouslySetInnerHTML={{__html: polyglot.t(LocalesKeys.addedFeatures, { LINK: 'https://www.goto.com/room/try' })}}></div>
            </div>
            <ul className={styles.DashList}>
                <li className={styles.JoinOnlyText}>{polyglot.t(LocalesKeys.hostYourMeetings)}​</li>
                <li className={styles.JoinOnlyText}>{polyglot.t(LocalesKeys.sharePresentations)}​</li>
                <li className={styles.JoinOnlyText}>{polyglot.t(LocalesKeys.syncRoomToCalendar)}​</li>
            </ul>
            </>
    );

    const successText =  () => (
        <div dangerouslySetInnerHTML={{__html: polyglot.t(LocalesKeys.activationSuccessDesc, { LINK: `${API_URL}/portal/#accounts/${currentAccountKey}/rooms` })}}></div>
    );

    return(
        <div className={styles.Activation}>
            <div className={styles.Header}><Logo /></div>
            <div className={styles.Title}>{polyglot.t(LocalesKeys.success)}</div>
            <div className={styles.Content}> {joinMode ? joinText() : successText()}</div>
            <div className={styles.SuccessFooter}>
                <div onClick={() => logout()} className={styles.ExternalLink}  >
                    <span className={styles.ExternalLink}>{polyglot.t(LocalesKeys.signOut)}</span>
                </div>
            </div>
        </div>
    );
};
